import { render, staticRenderFns } from "./UserPuzzleItem.vue?vue&type=template&id=248abb0d"
import script from "./UserPuzzleItem.vue?vue&type=script&lang=ts"
export * from "./UserPuzzleItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports